(function(angular){
	'use strict';

	angular
		.module('affixModule')
		.directive('affix', [
			'$timeout', 
			'$window', 
			'BREAKPOINTS',
			AffixFunction
		]);

	function AffixFunction($timeout, $window, BREAKPOINTS) {
		return {
			template: '<div ng-cloak ng-style="placeholderStyle"><div style="backface-visibility: hidden; z-index: 3;" ng-style="elementStyle()"><ng-transclude></ng-transclude></div></div>',
			transclude: true,
			restrict: 'A',
			link: function($scope, $element, $attrs) {
				
				if($window.innerWidth >= BREAKPOINTS.LG_START) {
				
					$scope.affixed = false;
					
					$scope.elementStyle = function() {
						
						var offset;
						if(typeof($attrs.affixOffset) === 'undefined') {
							offset = 0;
						} else {
							offset = parseInt($attrs.affixOffset);
						}
						
						var styles;
						
						if($attrs.affix === 'top') {
							if($scope.affixed) {
								styles = {
									width: $element[0].clientWidth + 'px',
									position: 'fixed',
									top: offset + 'px'
								};
							} else {
								styles = {
									width: $element[0].clientWidth + 'px',
									position: 'absolute',
									top: 0
								};
							}
						} else if($attrs.affix === 'bottom') {
							if($scope.affixed) {
								styles = {
									width: $element[0].clientWidth + 'px',
									position: 'fixed',
									bottom: offset + 'px'
								};
							} else {
								styles = {
									width: $element[0].clientWidth + 'px',
									position: 'absolute',
									top: 0
								};
							}
						}
						
						return styles;
					};
					
					var isAffixed = function() {
						var scrollY = $window.pageYOffset;
						var windowHeight = $window.innerHeight;
						var bottomEdgeOfViewportY = scrollY + windowHeight;
						var position = $element[0].getBoundingClientRect();
						var elementY = position.top + $window.pageYOffset;
						var bottomEdgeOfElementY = elementY + $element[0].offsetHeight;
						var offset;
						
						if(typeof($attrs.affixOffset) === 'undefined') {
							offset = 0;
						} else {
							offset = parseInt($attrs.affixOffset);
						}
						
						if($attrs.affix === 'top') {
							return scrollY + offset > elementY;
						} else if($attrs.affix === 'bottom') {
							return bottomEdgeOfViewportY < bottomEdgeOfElementY;
						}
					};
	
					$scope.placeholderStyle = {
						position: 'relative',
						height: $element[0].firstChild.firstChild.offsetHeight + 'px'
					};
	
					angular.element($window).bind('load', function() {
						
						$scope.placeholderStyle = {
							position: 'relative',
							height: $element[0].firstChild.firstChild.offsetHeight + 'px'
						};
						
						var newValue = isAffixed();
						if(newValue !== $scope.affixed) {
							$scope.affixed = newValue;
						}
									
						$scope.windowLoaded = true;
						$scope.$apply();
					});
	
					angular.element($window).bind('scroll', function() {
							
						var newValue = isAffixed();
						
						if($scope.windowLoaded && newValue !== $scope.affixed) {
							$scope.affixed = newValue;
							$scope.$apply();
						}
						
					});
				}
			}
		};
	}
})(window.angular);